import { SvgIcon } from '@mui/material';

const IconCheck = (props) => {
  return (
    <SvgIcon width="16" height="12" viewBox="0 0 16 12" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M5.71429 11.6L0 6.21541L1.6 4.70772L5.71429 8.58464L14.4 0.400024L16 1.90772L5.71429 11.6Z" />
    </SvgIcon>
  );
};

export default IconCheck;
